







import React from "react";
import { Link } from "react-router-dom";
import "../styles/Overview.css";

// Import your icon and image
import overviewIcon from "../assets/icons/overview-icon.png";
import overviewImage from "../image/Overview-image.png";

const Overview = () => {
  return (
    <div className="overview-container">
      {/* Image Slider */}
      <div className="overview-image-slider">
        <img src={overviewImage} alt="Overview Slider" />
      </div>

      {/* Main Content Container */}
      <div className="overview-content">
        {/* Content Card with title inside */}
        <div className="overview-card">
          {/* Ship wheel icon and title */}
          <div className="overview-header-container">
            <img src={overviewIcon} alt="Overview" className="overview-wheel-icon" />
            <div className="overview-header-title">Overview</div>
          </div>
          
          {/* Content */}
          <div className="overview-text-content">
            <h4 className="overview-panel-title">Welcome to ECL Shipping India Pvt. Ltd</h4>
            <p className="overview-text">
             ECL Shipping India Pvt Ltd was established in 2025 as a joint venture of ECL (Singapore) Pte Ltd, a 100 percent subsidiary of M/s. Eastern Car Liner, Japan.<br></br>
ECL-Shipping acts as the General Agent in India for M/s. Eastern Car Liner, one of the largest breakbulk operators from Japan.

            </p>
            
            <p className="overview-text">
              ECL Shipping India Pvt. Ltd., promoted by ECL (Singapore) Pte. Ltd., a wholly owned subsidiary of Eastern Car Liner, Japan, represents the ECL Group in India as its exclusive General Agent. The ECL Group operates a fleet of Pure Car and Truck Carriers (PCTs) and multi-purpose vessels with lifting capacities of up to 150 tons, providing global shipping services including extensive coverage of Indian ports.
            </p>
            
            <p className="overview-text">
             With modern multi-purpose tween deckers and PCTs, ECL offers regular sailings from all major Indian ports to destinations across South East Asia, the Far East, the Persian Gulf, and other international markets. Supported by a strong network of offices, agencies, stockyards, and infrastructure at major Indian ports, ECL Shipping has positioned itself as a leading provider of comprehensive logistics solutions to a diversified clientele.
            </p>
            
            <p className="overview-text">
             To ensure safe, reliable, and high-quality services with strict schedule adherence and operational flexibility, ECL Shipping India Pvt. Ltd. has developed a highly specialized operations team to manage all import and export activities for ECL vessels in India. Operating under the ECL funnel mark, the company remains dedicated to meeting the challenges of every voyage with efficiency and professionalism.
            </p>
           
          </div>
          
          {/* Right Side Panel */}
         <div className="overview-side-panel">
  <Link to="/management-standards-vision" className="overview-panel-link">
    <div className="overview-panel-section">
      <h4 className="overview-panel-title">
        Management, Standards & Vision
      </h4>

      <p className="overview-panel-text">
        The top management of ECL Shipping brings together over ten decades of
        combined experience in the shipping industry. The company considers
        its people as its greatest strength, combining skills, experience,
        teamwork, and focus to consistently deliver quality services. With
        this approach, ECL Shipping strives to be its clients’ trusted Partner
        of Choice.
      </p>

    

      <span className="overview-readmore">Read More →</span>
    </div>
  </Link>

  <Link to="/joint-venture-partners" className="overview-panel-link">
    <div className="overview-panel-section">
      <h4 className="overview-panel-title">Joint Venture Partners</h4>

      <p className="overview-panel-text">
        ECL Shipping India Pvt. Ltd. is associated with ECL (Singapore) Pte.
        Ltd., which is a major shareholder in the company. ECL (Singapore)
        Pte. Ltd. represents the ECL Group’s interests and plays a key role in
        supporting ECL Shipping’s operations in the region.
      </p>

     

      <span className="overview-readmore">Read More →</span>
    </div>
  </Link>
</div>

        </div>
      </div>
    </div>
  );
};

export default Overview;